<script>
    import {createEventDispatcher, onDestroy, onMount} from 'svelte'

    export let version
    let modal
    let dispatch = createEventDispatcher()

    onMount(async () => {
        checkVersion()
    })

    const checkVersion = () => {
        const div = document.getElementById('changelog')
        const lastVersion = div.firstChild.firstChild.innerHTML
        if (lastVersion < ('v' + version)) {
            const newVersionDiv = document.createElement('div')
            newVersionDiv.classList.add('changelogDiv')
            const newVersion = document.createElement('span')
            newVersion.classList.add('version')
            newVersion.innerHTML = 'v' + version
            const changes = document.createElement('span')
            changes.innerHTML = 'Updated to ' + version

            newVersionDiv.appendChild(newVersion)
            newVersionDiv.appendChild(changes)
            div.prepend(newVersionDiv)
        }
    }

    const close = () => {
        dispatch('close')
    }

    const handle_keydown = e => {
        if (e.key === 'Escape') {
            close();
            return;
        }

        if (e.key === 'Tab') {
            // trap focus
            const nodes = modal.querySelectorAll('*');
            const tabbable = Array.from(nodes).filter(n => n.tabIndex >= 0);
            let index = tabbable.indexOf(document.activeElement);
            if (index === -1 && e.shiftKey) index = 0;

            index += tabbable.length + (e.shiftKey ? -1 : 1);
            index %= tabbable.length;

            tabbable[index].focus();
            e.preventDefault();
        }
    };

    const previously_focused = typeof document !== 'undefined' && document.activeElement;

    if (previously_focused) {
        onDestroy(() => {
            previously_focused.focus();
        });
    }
</script>

<svelte:window on:keydown={handle_keydown}/>

<div class="modal-background" on:click={close}></div>

<div class="flex flex-col mx-2 mb-2 z-30 modal shadow-md" role="dialog" aria-modal="true" bind:this={modal}>
    <div class="flex flex-row justify-between mt-1 border-b-2 border-cyan-700" >
        <h1 class="z-10 text-xl xl:text-2xl 2xl:text-3xl">Changelog</h1>
    </div>
    <div class="container">
        <div id="changelog">
            <div class="changelogDiv">
                <span class="version">v2.2.2</span>
                <span>Fixed: maintenance mode, should be static red </span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.1.2</span>
                <span>Fixed manual tester status not blinking </span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.1.1</span>
                <span>Fixed OVERDUE status not blinking </span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.1.00</span>
                <span>If there is red Optiline error (like camera error or no DUT detected): start blinking grey-red immediately</span>
                <span>If there is maintenance mode active: do not blink</span>
                <span>If green idle state exceed 3 minutes: blink grey-green (do not reset time counter)</span>
                <span>If yellow state exceed 3 minutes: blink grey-orange (do not reset time counter)</span>
                <span>Move UR1 testers to 4th row to keep robots grouping</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.10</span>
                <span>If tester is idle for 5 or more minutes box will start blinking </span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.9</span>
                <span>02.06.2022: Group testers by robot name</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.8</span>
                <span>24.05.2022: CSS changes.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.7</span>
                <span>23.05.2022: Import version and testers from json and polish the CSS.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.6</span>
                <span>19.05.2022: Remove json imports, they did not work.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.5</span>
                <span>19.05.2022: Import version and testers from json files.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.4</span>
                <span>19.05.2022: Change port to 4141.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.3</span>
                <span>19.05.2022: Remove json imports.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.2</span>
                <span>19.05.2022: Fix default-0.json file.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.1</span>
                <span>19.05.2022: Add process.json</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v2.0.0</span>
                <span>18.05.2022: Refactored project to Svelte and added automatic changelog.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.1.7</span>
                <span>13.08.2021: Added extra slots for manual in feed line (Opti-03 and 07).</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.1.6</span>
                <span>30.06.2021: Added static Robot name to each optiline tester monitor.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.1.5</span>
                <span>10.05.2021: Made page more responsive on different screen sizes.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.1.4</span>
                <span>07.05.2021: Fixed status box size changing when status appears.</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.1.3</span>
                <span>05.05.2021: Fixed login button overlapping with version. Added new config option to select what testers to display</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.1.2</span>
                <span>03.05.2021: Changed API config</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.1.1</span>
                <span>03.05.2021: Added config option for login</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.1.0</span>
                <span>30.04.2021: Added page header with Reconext logo, changelog modal and testcycle steps</span>
            </div>
            <div class="changelogDiv">
                <span class="version">v1.0.0</span>
                <span>05.03.2021: Initial commit.</span>
            </div>
        </div>
    </div>
</div>

<style>
    .container {
        max-height: 25em !important;
        max-width: 65em !important;
        margin-top: 0.5em;
    }

    :global(.content) {
        padding: 0 !important;
    }

    .modal-background {
        z-index: 10;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
    }

    .modal {
        z-index: 10;
        position: absolute;
        left: 50%;
        top: 50%;

        max-height: calc(100vh - 4em);
        min-width: 25em;
        overflow: auto;
        transform: translate(-50%,-50%);
        padding: 1em;
        border-radius: 0.2em;
        background: white;
    }

</style>
